import classNames from 'classnames';
import React, { FC } from 'react';

export interface CardTagProps {
  className?: string;
  label: string;
}

export const CardTag: FC<CardTagProps> = ({ className, label }) => (
  <div
    data-cy={`card__tag-${label.replace(' ', '-').toLowerCase()}`}
    className={classNames(`bg-brand-yellow-500 h-5 rounded-sm px-2 py-1 font-medium text-xs uppercase`, className)}
  >
    {label}
  </div>
);
